export default {"src":"/_next/static/media/reddit-black.1c5f78a9.svg","height":15,"width":16};